import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Button } from 'semantic-ui-react';
import ApiUtils from '../../helper/ApiUtils';
import Spinner from '../common/Spinner';
import Language_Add from './Language_Add';
import Language_list from './Language_list';

const LanguagePage = () => {
  const history = useHistory();
  const location = useLocation();

  const [loading, setloading] = useState(false);
  //網址判斷
  useEffect(() => {
    // post_Style_GetClientList
    getClient();
  }, [location]);

  const getClient = async () => {
    /**
     * 廠商
     * */
    const getClient_jsonData = await ApiUtils.post_sql(
      `${ApiUtils.post_Style_GetClientList}`
    );
    // [{"fId":1,"fName":"Medialink Group Ltd.","fEmail":null,"fPhone":null,"fSerialNumber":null,"fLevel":1},{"fId":2,"fName":"酷遊天國際旅行社股份有限公司","fEmail":null,"fPhone":null,"fSerialNumber":null,"fLevel":1}]
    setclientList(getClient_jsonData);

    /**
     * 語系
     * */
    const LanguageList_jsonData = await ApiUtils.post_sql(
      `${ApiUtils.post_Style_GetLanguageList}`
    );
    //語系列表
    setLanguageList(LanguageList_jsonData);
    // {
    //     "fId": 1,
    //     "fName": "繁體中文",
    //     "fCode": "zhtw",
    //     "fCountry": null
    // },

    const getlist_jsonData = await ApiUtils.post_sql(
      `${ApiUtils.post_Style_GetStyleList}`
    );
    // [{"fId":1,"fName":"Medialink Group Ltd.","fEmail":null,"fPhone":null,"fSerialNumber":null,"fLevel":1},{"fId":2,"fName":"酷遊天國際旅行社股份有限公司","fEmail":null,"fPhone":null,"fSerialNumber":null,"fLevel":1}]
    setList(getlist_jsonData);
    settotal(getlist_jsonData.length);
  };

  const [List, setList] = useState([]);
  const [total, settotal] = useState(0);

  //廠商
  const [clientList, setclientList] = useState(null);
  const [LanguageList, setLanguageList] = useState(null); //語系選項

  const [showAddForm, setshowAddForm] = useState(false);
  const [showEditForm, setshowEditForm] = useState(false);

  const [editData, seteditData] = useState(null);

  return (
    <div className=' pb-2 position-relative p-3'>
      {loading === true ? (
        <Spinner />
      ) : (
        <div>
          <Button.Group>
            <Button
              color={showAddForm === true ? 'grey' : 'green'}
              onClick={() => {
                setshowAddForm(!showAddForm);
              }}
            >
              {showAddForm === true ? 'Close Add Form' : 'Add'}
            </Button>
          </Button.Group>

          {clientList !== null && LanguageList !== null ? (
            <Language_list
              List={LanguageList}
              total={total}
              clientList={clientList}
              LanguageList={LanguageList}
              CallToUpdate={(fStyleId) => {
                let editArray = LanguageList.filter(
                  (data) => data['fId'] === fStyleId
                );
                const editData = editArray[0];
                seteditData(editData);
                setshowEditForm(false);

                setTimeout(
                  function () {
                    setshowEditForm(true);
                  }.bind(this),
                  500
                );
              }}
            />
          ) : null}

          {showAddForm === true ? (
            <Language_Add
              type={'add'}
              finishUpdate={() => {
                getClient();
              }}
            />
          ) : null}

          {showEditForm === true ? (
            <Language_Add
              type={'edit'}
              editData={editData}
              finishUpdate={() => {}}
            />
          ) : null}
        </div>
      )}
    </div>
  );
};

export default LanguagePage;



// WEBPACK FOOTER //
// ./src/components/Language/LanguagePage.js